module.exports = __webpack_public_path__ + "static/media/5H.1934d77c.svg";